<template>
	<div class="ic-programmers-list">
		<div class="ic-programmers-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">IC Programmers Solutions</span>
			</div>

			<div class="list">
				<ul>
					<li>
						<p>
							VVDI PROG is a professional programmer that supports read and write data on EEPROM, FLASH, MCU memory, and ECU.</p>
						<div class="pic-txt">
							<img class="x-flow" :src="solution_image_01" alt="Xhorse"/>
							<div class="txt x-flow">
								<div class="hh">Main Functions:</div>
								<ul>
									<li>- Support read&write lots of chips；</li>
									<li>- Support chip data verification, check blank function；</li>
									<li>- Support data file comparison function；</li>
									<li>- Support read&write BMW N20, N55 ECU(show ISN directly)；</li>
									<li>- Stable read&write MC9S12XE series chips(5M48H/1N35H/2M53J/3M25J, etc)；</li>
									<li>- Support erase M35080/D80(M350803/M350806/M35080V6/M35080VP/D80/D160)；</li>
									<li>- Support NEC series chip；</li>
								</ul>
							</div>
						</div>
					</li>

					<li>
						<p>
							This new MINI PROG is the result of intelligence and speed to provide users easier programming solutions. You can do the programming work anywhere, your house, car garage, workshop, office, outdoor, coffee shop, car, etc. Just take it anywhere, and make it any time! The Three Detect Connectors(Test Heads) Suitable for various Chips. Users can complete the programming work by connecting MINI PROG to the Xhorse App via Bluetooth & Wifi.
						</p>
						<div class="pic-txt">
							<img class="x-flow" :src="solution_image_02" alt="Xhorse"/>
							<div class="txt x-flow">
								<div class="hh" style="margin-top: 53px">Main Functions:</div>
								<ul>
									<li>- Repair multiple modules;</li>
									<li>- Data local & cloud storage;</li>
									<li>- Edit data on Xhorse App;</li>
									<li>- Read & write EEPROM data and MCU data;</li>
									<li>- Directly read & write data free from soldering chips;</li>
								</ul>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_ic_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_ic_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
	.list > ul > li:last-child > p {
		margin-bottom: 1.375rem;
	}

	.list > ul > li:last-child {
		padding-top: 4rem;
	}

	.list > ul > li:first-child {
		border-bottom: 1px solid #D7D7D7;
		padding-bottom: 4rem;
	}

	.txt > ul > li {
		width: 100%;
		/* height: 32px; */
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: left;
		line-height: 1.5rem;
		white-space: normal;
		word-break: break-all;
	}

	.txt > ul {
		width: 100%;
		height: calc(100% - 1.75rem - 1.5rem);
	}

	.txt > .hh {
		width: 100%;
		height: 1.75rem;
		font-size: 1rem;
		color: #3B3A38;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
		margin-bottom: 1.5rem;
	}

	.pic-txt > .txt {
		width: calc(100% - 20.125rem - 2rem);
		height: 20.125rem;
		margin-left: 2rem;
		border: none;
	}

	.pic-txt > img {
		height: 18rem;
		border: none;
	}

	.pic-txt {
		width: 100%;
		border: none;
		height: 18rem;
	}

	.list > ul > li > p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-bottom: 2rem;
	}

	.list > ul > li {
		width: 100%;
		border: none;
	}

	.list > ul {
		width: 100%;
		height: 57.4375rem;
	}

	.list {
		width: 54.5rem;
		margin-left: 7rem;
		height: 57.4375rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.ic-programmers-con {
		width: 61.5rem;
		height: 71.9375rem;
		border: none;
		margin-left: 0;
	}

	.ic-programmers-list {
		width: 100%;
		height: 71.9375rem;
		border: none;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 4rem;
		font-family: "Open Sans";
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;

	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-ic-programmers.vue